import React from 'react'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import { Input } from 'antd'
import { fixDescriptionValue } from '../../utils'

const wrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px',
  padding: '20px 24px',
  maxWidth: '900px',
}

const labelStyle = {
  display: 'block',
  marginBottom: '6px',
  fontWeight: 500,
}

const rowStyle = {
  display: 'flex',
  gap: '24px',
  flexWrap: 'wrap',
}

const dividerStyle = {
  borderTop: '1px solid #f0f0f0',
  margin: '4px 0',
}

const TvaCard97Extension = props => {
  const { data, handleExtSave } = props

  const { string5, string6, extendedDes } = data

  // Same rule as the card97 Description field: strip disallowed special
  // characters and convert tabs to spaces.
  const handleDescChange = (id, value) =>
    handleExtSave(id, fixDescriptionValue(value || ''))

  const descArea = (id, value) => (
    <Input.TextArea
      allowClear
      value={value}
      onChange={e => handleDescChange(id, e.target.value)}
      key={id}
      rows={3}
      maxLength={1000}
      style={{ width: '100%', resize: 'vertical' }}
    />
  )

  const field = (label, control) => (
    <div>
      <label style={labelStyle}>{label}</label>
      {control}
    </div>
  )

  return (
    <div style={wrapperStyle}>
      <div style={rowStyle}>
        {field(
          'Condition Rep# :',
          <Input
            value={string5}
            onChange={e => handleExtSave('string5', e.target.value)}
            key="string5"
            style={{ width: '300px', maxWidth: '100%' }}
          />
        )}

        {field(
          'ITOA ID :',
          <Input
            value={string6}
            onChange={e => handleExtSave('string6', e.target.value)}
            key="string6"
            style={{ width: '300px', maxWidth: '100%' }}
          />
        )}
      </div>

      <div style={dividerStyle} />

      {field(
        'Justification for exclusion :',
        descArea('extendedDes', extendedDes)
      )}
    </div>
  )
}

export default connect(state => ({ targetInfo: getApiTargetInfo(state) }))(
  TvaCard97Extension
)
